import { BluetoothIcon, DoorIcon, KeyIcon, PasswordIcon } from '@phosphor-icons/react'
import { TFunction } from 'i18next'

import { theme } from '@/theme/theme'

export const getAccessTypeBadges = (t: TFunction<['visitors']>) =>
  [
    {
      color: theme.colors.green500,
      // Note: As it was described in EL-14633 - keylessAccess is temporarly treated as physical key access,
      // and keyAccess is treated as keyless integration
      field: 'keylessAccess',
      icon: KeyIcon,
      id: 'key-release',
      tooltip: t('visitors:dashboard.accessTypeCell.keyReleaseTooltip'),
    },
    {
      color: theme.colors.purple500,
      // Note: As it was described in EL-14633 - keylessAccess is temporarly treated as physical key access,
      // and keyAccess is treated as keyless integration
      field: 'keyAccess',
      icon: BluetoothIcon,
      id: 'keyless-access',
      tooltip: t('visitors:dashboard.accessTypeCell.keylessAccessTooltip'),
    },
    {
      color: theme.colors.blue500,
      field: 'pinCode',
      icon: PasswordIcon,
      id: 'pincode-access',
      tooltip: t('visitors:dashboard.accessTypeCell.pincodeAccessTooltip'),
    },
    {
      color: theme.colors.orange500,
      field: 'customAccess',
      icon: DoorIcon,
      id: 'permission-to-enter',
      tooltip: t('visitors:dashboard.accessTypeCell.permissionToEnterTooltip'),
    },
  ] as const
